module.exports = __webpack_public_path__ + "media/images/athletes/2387-27185a3933b20c5544fee0a9745fe02d.png";